<template>
  <div class="kt-header__brand-logo">
    <a href="" @click.prevent="$emit('onClick')">
      <img class="kt-header__brand-logo-default" src="/img/ttc-logo.png" width="45">
    </a>
  </div>
</template>

<script>
export default {
  name: 'NavbarMainLogo',
  props: ['onClick']
}
</script>
